import { render } from "./Storage.vue?vue&type=template&id=0b940d92"
import script from "./Storage.vue?vue&type=script&lang=js"
export * from "./Storage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Storage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b940d92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b940d92', __exports__)) {
    api.reload('0b940d92', __exports__)
  }
  
  module.hot.accept("./Storage.vue?vue&type=template&id=0b940d92", () => {
    api.rerender('0b940d92', render)
  })

}


export default __exports__